import { Eye } from 'lucide-react'
import { useState } from 'react'
import { streetViewUrl } from '../../domain/streetView'

// « Voir la maison » : vue de rue Google chargée seulement à la demande, jamais stockée pour le hors-ligne (licence).
// L'adresse affichée fait foi; l'image peut être ancienne ou absente.

export interface StreetViewProps {
  apiKey: string | undefined
  position: { lat: number; lng: number } | null
  online: boolean
  address: string
}

export function StreetView({ apiKey, position, online, address }: StreetViewProps) {
  const [state, setState] = useState<'idle' | 'loading' | 'shown' | 'failed'>('idle')
  const unavailable = !apiKey
    ? 'Vue de rue indisponible : carte non configurée sur cette tablette.'
    : !position
      ? 'Vue de rue indisponible : position de la résidence inconnue.'
      : !online
        ? 'Vue de rue indisponible hors ligne.'
        : null

  return (
    <div className="field-fiche__block op-street">
      <span className="field-eyebrow">Voir la maison</span>
      {unavailable ? (
        <p className="field-fiche__muted">{unavailable}</p>
      ) : state === 'idle' ? (
        <button
          type="button"
          className="field-button field-button--outline field-button--tall"
          onClick={() => {
            setState('loading')
          }}
        >
          <Eye aria-hidden="true" /> Charger la vue de rue
        </button>
      ) : state === 'failed' ? (
        <p className="field-fiche__muted">Aucune vue de rue disponible pour cette adresse.</p>
      ) : apiKey && position ? (
        <img
          className="op-street__image"
          src={streetViewUrl(apiKey, position)}
          alt={`Vue de rue près du ${address}`}
          onLoad={() => {
            setState('shown')
          }}
          onError={() => {
            setState('failed')
          }}
        />
      ) : null}
      {state === 'loading' ? <p className="field-fiche__muted">Chargement…</p> : null}
      <p className="field-fiche__muted">L’image peut dater de plusieurs années. L’adresse ci-contre fait foi.</p>
    </div>
  )
}
